import { Navigate, RouteObject } from "react-router";

import { TasksHome } from "./pages";
import PageError from "@/shared/ui/errors/PageError";
import * as Sentry from "@sentry/react";

export const taskRoutes: RouteObject[] = [
	{
		path: "tasks/*",
		children: [
			{
				index: true,
				element: (
					<Sentry.ErrorBoundary
						fallback={(fallbackProps) => (
							<PageError
								error={fallbackProps.error}
								componentStack={fallbackProps.componentStack}
								reset={() => fallbackProps.resetError()}
							/>
						)}
					>
						<TasksHome />
					</Sentry.ErrorBoundary>
				),
			},
			{
				path: "tasks",
				element: <Navigate to="/tasks?tab=active" replace />,
			},
		],
	},
];
